<template>
  <div class="ion-padding static-button-conf-wrapper">
    <div class="domainContainer">
      <p class="title ion-no-margin paddingBottom">Button title</p>
      <VTextField type="text" :modelValue="title" readonly :maxlength="16" placeholder="Button title" aria-label="Button title" appearance="ghost" class="vivid-input"></VTextField>
    </div>
    <div class="domainContainer">
      <p class="title ion-no-margin paddingBottom">Button action</p>
      <VTextField type="text" :modelValue="valueToShow" readonly :maxlength="16" placeholder="Button action" aria-label="Button action" appearance="ghost" class="vivid-input"></VTextField>
    </div>
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {  
    }
  },
  props: {
    clickedButton: {
      type: Object,
      default: () => { return {}; }
    }
  },
  computed: {
    title() {
      return this.clickedButton.text || this.clickedButton.title;
    },
    valueToShow() {
      if (this.clickedButton.sub_type == "phone_number") {
        return this.clickedButton.phone_number;
      }
      else if (this.clickedButton.sub_type == "quick_reply") {
        return this.clickedButton.payload;
      }
      return "";
    }
  }
}
</script>

<style scoped>
.domainContainer{
  padding-bottom: 20px;
  margin-bottom: 10px;
	width: 100%;
}
.title {
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  line-height: 16px;
}
</style>